import React from 'react';
import { FunctionComponent } from 'react';
import styles from './styles.module.scss';

export type WeekdayLabelProps = {
    dayOfWeekIndex: number;
    long: string;
    narrow: string;
    short: string;
    isFirst: boolean;
    isLast: boolean;
};

export const DefaultWeekdayLabel: FunctionComponent<WeekdayLabelProps> = ({ short, long }) => {
    return (
        <span aria-label={long} className={styles.weekday}>
            {short}
        </span>
    );
};
